routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.templateDetail', {
      url: __env.routes.templateDetail,
      template: `<template-detail sh-ctrl="shCtrl"></template-detail>`,
      params: {
        templateId: null
      }
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/templates/template-detail/template-detail.config.js
 **/